<ng-container shareDeviceSession [pageId]="pageId">
  <div class="navbar">
    <div class="navbar__title">
      <span>{{title}}</span>
    </div>
    <div class="navbar__contents">
      <share-search-condition-panel #conditionPanel blFocusControl blCustomFocus
        [isDisplayDetailToggle]="true"
        [detailToggleBtnText]="'詳細条件'"
        (searchEvent)="onSearch()"
        (clearEvent)="onClear()"
      >
        <div id="basic-condition" class="u-flex basic-cond" basic-condition>
          <!-- 組織コード -->
          <div class="search-condition__item">
            <span class="item-label">管理組織</span>
            <div class="item-options">
              <share-organization-combo-box
                [withAllCompanyDiv]="WithAllCompanyDiv.AllCompany"
                [value]="organizationCode"
                (changeEvent)="onChangeOrgCode($event)"
              ></share-organization-combo-box>
            </div>
          </div>
        </div>
        <div class="detail-cond" detail-condition>
          <div class="row">
            <div class="col-md-4 col-xs-4 col-lg-4">
              <label>顧客フリガナ</label>
              <div class="form-group">
                <bl-text-input blCustomFocus
                  #kanaInput
                  [(value)]="detailCondition.customerNameKana1"
                  [id]="'CustomerNameKana1'"
                  [maxlength]="60"
                  [option]="{ allows: ['katakana', 'number', 'alphabet', 'symbol'], convertKana: true}"
                ></bl-text-input>
              </div>
            </div>
            <div class="col-md-4 col-xs-4 col-lg-4">
              <label>電話番号</label>
              <div class="form-group">
                <bl-text-input #telePhoneInput blCustomFocus
                  [(value)]="detailCondition.contactInfoTel"
                  [id]="'TelNumber'"
                  [maxlength]="16"
                  [option]="{ allows: ['telephone'], convertHalf: true }"
                ></bl-text-input>
              </div>
            </div>
            <div class="col-md-4 col-xs-4 col-lg-4">
              <label>ナンバープレート（下4桁）</label>
              <div class="form-group">
                <bl-text-input blCustomFocus
                  #plateNumberInput
                  [(value)]="detailCondition.numPlateSeriesSpecifNum"
                  [id]="'PlateNumber'"
                  [maxlength]="4"
                  [option]="{ allows: ['number'], convertHalf: true }"
                ></bl-text-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-xs-6 col-lg-6">
              <label>メールアドレス</label>
              <div class="form-group">
                <bl-text-input #telePhoneInput blCustomFocus
                  [(value)]="detailCondition.contactInfoEmail"
                  [id]="'Email'"
                  [maxlength]="256"
                  [option]="{ allows: ['number', 'alphabet', 'symbol'], convertHalf: true }"
                ></bl-text-input>
              </div>
            </div>
            <div class="col-md-6 col-xs-6 col-lg-6">
              <label>本人認証連絡先</label>
              <div class="form-group">
                <bl-text-input #telePhoneInput blCustomFocus
                  [(value)]="detailCondition.useAuthContact"
                  [id]="'UseAuthContact'"
                  [maxlength]="256"
                  [option]="{ allows: ['number', 'alphabet', 'symbol'], convertHalf: true }"
                ></bl-text-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-xs-12 col-lg-12">
              <label>お客様情報登録日時</label>
              <div class="u-flex align-items-center form-group">
                <div class="w-330px">
                  <bl-date
                    [(value)]="detailCondition.profileRegistDateTimeStart">
                  </bl-date>
                </div>
                <div class="wave-dash">〜</div>
                <div class="w-330px">
                  <bl-date
                    [(value)]="detailCondition.profileRegistDateTimeEnd">
                  </bl-date>
                </div>
              </div>
            </div>
          </div>
        </div>
      </share-search-condition-panel>
    </div>
  </div>

  <div class="l-contents search-page">
    <div class="search-result">
      <bl-reference-grid #refGrid
        [gridHeight]="'auto'"
        [rowHeight]="40"
        [gridOptions]="gridOptions"
        [isOperable]="false"
        [noRowsMessage]="noRowsMessage"
        [pagination]="true"
        [pageSizePatterns]="gridSizePatterns"
        [totalCount]="resultCount"
        (onReady)="onReadyGrid()"
        (gotoPrevPage)="onClickPrevPage()"
        (gotoNextPage)="onClickNextPage()"
        (selectedRowEvent)="onSelectedRow($event)"
      >
      </bl-reference-grid>
    </div>
  </div>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/profile-entries-page.component.html